<template>
    <nav v-if="links!==undefined" class="flex items-center justify-between" role="navigation">
        <div class="flex justify-between flex-1 sm:hidden">
            <span v-if="onFirstPage"
                class="relative inline-flex items-center px-4 py-2 text-sm font-medium text-gray-500 bg-gray-100 border border-gray-300 cursor-default leading-5">
                <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                            <path clip-rule="evenodd"
                                    d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
                                    fill-rule="evenodd"/>
                        </svg>
            </span>
            <a href="#" v-else @click="loadData(previousPageUrl)"
                          class="relative inline-flex items-center px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 leading-5 hover:text-gray-500 focus:outline-none focus:ring ring-gray-300 focus:border-blue-300 active:bg-gray-100 active:text-gray-700 transition ease-in-out duration-150">
                <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                    <path clip-rule="evenodd"
                          d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
                          fill-rule="evenodd"/>
                </svg>
            </a >

            <a href="#" v-if="hasMorePages" @click="loadData(nextPageUrl)"
                          class="relative inline-flex items-center px-4 py-2 ml-3 text-sm font-medium text-gray-700 bg-white border border-gray-300 leading-5 hover:text-gray-500 focus:outline-none focus:ring ring-gray-300 focus:border-blue-300 active:bg-gray-100 active:text-gray-700 transition ease-in-out duration-150">
                <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                    <path clip-rule="evenodd"
                          d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                          fill-rule="evenodd"/>
                </svg>
            </a>
            <span v-else
                  class="relative inline-flex items-center px-4 py-2 ml-3 text-sm font-medium text-gray-500 bg-gray-100 border border-gray-300 cursor-default leading-5">
                    <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                    <path clip-rule="evenodd"
                          d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                          fill-rule="evenodd"/>
                </svg>
                </span>
        </div>

        <div class="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between">
            <div>
                <span class="relative z-0 inline-flex">
                        <span v-if="onFirstPage" aria-disabled="true"
                              aria-hidden="true"
                              class="relative inline-flex items-center px-2 py-2 text-sm font-medium text-gray-500 bg-gray-100 border border-gray-300 cursor-default leading-5">
                                <svg class="w-5 h-5" fill="currentColor"
                                     viewBox="0 0 20 20">
                                    <path clip-rule="evenodd"
                                          d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
                                          fill-rule="evenodd"/>
                                </svg>
                        </span>
                        <a href="#" v-else @click="loadData(previousPageUrl)"
                                      class="relative inline-flex items-center px-2 py-2 text-sm font-medium text-gray-500 bg-white border border-gray-300 leading-5 hover:text-gray-400 focus:z-10 focus:outline-none focus:ring ring-gray-300 focus:border-blue-300 active:bg-gray-100 active:text-gray-500 transition ease-in-out duration-150"
                                      rel="prev">
                            <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                                <path clip-rule="evenodd"
                                      d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
                                      fill-rule="evenodd"/>
                            </svg>
                        </a>

                        <div v-if="currentPage > 5">
                            <a href="#"
                             @click="loadData(link + '1')"
                                class="relative inline-flex items-center px-4 py-2 -ml-px text-sm font-medium text-gray-700 bg-white border border-gray-300 leading-5 hover:text-gray-500 focus:z-10 focus:outline-none focus:ring ring-gray-300 focus:border-blue-300 active:bg-gray-100 active:text-gray-700 transition ease-in-out duration-150"
                            >
                                1
                            </a>

                            <span aria-disabled="true"
                                aria-hidden="true"
                                class="relative inline-flex items-center px-2 py-2 text-sm font-medium text-gray-500 bg-gray-100 border border-gray-300 cursor-default leading-5">
                                ...
                            </span>
                        </div>

                        <div v-if="currentPage > 1">
                            <a href="#"
                             @click="loadData(link + (currentPage > 2 ? currentPage - 2 : '1'))"
                                class="relative inline-flex items-center px-4 py-2 -ml-px text-sm font-medium text-gray-700 bg-white border border-gray-300 leading-5 hover:text-gray-500 focus:z-10 focus:outline-none focus:ring ring-gray-300 focus:border-blue-300 active:bg-gray-100 active:text-gray-700 transition ease-in-out duration-150"
                            >
                                {{ (currentPage > 2 ? currentPage - 2 : '1') }}
                            </a>
                        </div>

                        <div v-if="currentPage > 2">
                            <a href="#"
                             @click="loadData(link + (currentPage - 2))"
                                class="relative inline-flex items-center px-4 py-2 -ml-px text-sm font-medium text-gray-700 bg-white border border-gray-300 leading-5 hover:text-gray-500 focus:z-10 focus:outline-none focus:ring ring-gray-300 focus:border-blue-300 active:bg-gray-100 active:text-gray-700 transition ease-in-out duration-150"
                            >
                                {{ currentPage - 1 }}
                            </a>
                        </div>

                        <!-- Current page -->
                        <a href="#"
                         @click="loadData(link + currentPage)"
                            class="relative inline-flex items-center px-4 py-2 -ml-px text-sm font-medium text-gray-700 bg-gray-300 font-bold border border-gray-300 leading-5 hover:text-gray-500 focus:z-10 focus:outline-none focus:ring ring-gray-300 focus:border-blue-300 active:bg-gray-100 active:text-gray-700 transition ease-in-out duration-150"
                        >
                            {{ currentPage }}
                        </a>

                        <div v-if="currentPage < total - 1">
                            <a href="#"
                             @click="loadData(link + (currentPage + 1))"
                                class="relative inline-flex items-center px-4 py-2 -ml-px text-sm font-medium text-gray-700 bg-white border border-gray-300 leading-5 hover:text-gray-500 focus:z-10 focus:outline-none focus:ring ring-gray-300 focus:border-blue-300 active:bg-gray-100 active:text-gray-700 transition ease-in-out duration-150"
                            >
                                {{ currentPage + 1 }}
                            </a>
                        </div>

                        <div v-if="currentPage < total - 2">
                            <a href="#"
                             @click="loadData(link + (currentPage + 2))"
                                class="relative inline-flex items-center px-4 py-2 -ml-px text-sm font-medium text-gray-700 bg-white border border-gray-300 leading-5 hover:text-gray-500 focus:z-10 focus:outline-none focus:ring ring-gray-300 focus:border-blue-300 active:bg-gray-100 active:text-gray-700 transition ease-in-out duration-150"
                            >
                                {{ currentPage + 2 }}
                            </a>
                        </div>

                        <div v-if="currentPage < total - 5">
                            <span aria-disabled="true"
                                aria-hidden="true"
                                class="relative inline-flex items-center px-2 py-2 text-sm font-medium text-gray-500 bg-gray-100 border border-gray-300 cursor-default leading-5">
                                ...
                            </span>
                        </div>

                        <div v-if="currentPage < total - 4">
                            <a href="#"
                             @click="loadData(link + (total - 2))"
                                class="relative inline-flex items-center px-4 py-2 -ml-px text-sm font-medium text-gray-700 bg-white border border-gray-300 leading-5 hover:text-gray-500 focus:z-10 focus:outline-none focus:ring ring-gray-300 focus:border-blue-300 active:bg-gray-100 active:text-gray-700 transition ease-in-out duration-150"
                            >
                                {{ total - 2 }}
                            </a>
                        </div>

                        <div v-if="currentPage < total - 3">
                            <a href="#"
                             @click="loadData(link + (total - 1))"
                                class="relative inline-flex items-center px-4 py-2 -ml-px text-sm font-medium text-gray-700 bg-white border border-gray-300 leading-5 hover:text-gray-500 focus:z-10 focus:outline-none focus:ring ring-gray-300 focus:border-blue-300 active:bg-gray-100 active:text-gray-700 transition ease-in-out duration-150"
                            >
                                {{ total - 1 }}
                            </a>
                        </div>

                        <div v-if="currentPage < total">
                            <a href="#"
                             @click="loadData(link + total)"
                                class="relative inline-flex items-center px-4 py-2 -ml-px text-sm font-medium text-gray-700 bg-white border border-gray-300 leading-5 hover:text-gray-500 focus:z-10 focus:outline-none focus:ring ring-gray-300 focus:border-blue-300 active:bg-gray-100 active:text-gray-700 transition ease-in-out duration-150"
                            >
                                {{ total }}
                            </a>
                        </div>

                        <a href="#" v-if="hasMorePages"
                     @click="loadData(nextPageUrl)"
                                      class="relative inline-flex items-center px-2 py-2 -ml-px text-sm font-medium text-gray-500 bg-white border border-gray-300 leading-5 hover:text-gray-400 focus:z-10 focus:outline-none focus:ring ring-gray-300 focus:border-blue-300 active:bg-gray-100 active:text-gray-500 transition ease-in-out duration-150">
                            <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                                <path clip-rule="evenodd"
                                      d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                                      fill-rule="evenodd"/>
                            </svg>
                        </a>
                        <span v-else aria-disabled="true"
                              aria-hidden="true"
                              class="relative inline-flex items-center px-2 py-2 -ml-px text-sm font-medium text-gray-500 bg-gray-100 border border-gray-300 cursor-default leading-5">
                            <svg class="w-5 h-5" fill="currentColor"
                                 viewBox="0 0 20 20">
                                <path clip-rule="evenodd"
                                      d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                                      fill-rule="evenodd"/>
                            </svg>
                        </span>
                </span>
            </div>
        </div>
    </nav>

</template>

<script>
export default {
    props: {
        links: Object,
        link: String,
    },

    methods: {
        isFirstOrLastOrDots(index,links_length,label) {
            return index===0 || index===links_length-1 || label.includes('...')
        },

        loadData(endpoint){
            this.$emit('load-json', endpoint);
        }
    },
    computed: {
        currentPage() {
            return this.links['current_page'];
        },
        total() {
            return this.links['total_pages'];
        },
        onFirstPage() {
            return this.links['current_page'] === 1;
        },
        hasMorePages() {
            return this.links['current_page'] < this.links['total_pages'];
        },
        nextPageUrl() {
            return this.links['links']['next'];
        },
        previousPageUrl() {
            return this.links['links']['previous'];
        },
    }
}
</script>
